import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { dealEventLogControllerGetDealEventsInfiniteOptions } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import type { DealEventLogQuery } from '@dealstack/frontend/app/pages/Project/DealEventLog/DealEventLog.types.ts';

export const DEAL_EVENT_PAGE_SIZE = 50;

export const useDealEventFeed = (dealId: string, filters?: DealEventLogQuery) => {
	const query = useInfiniteQuery({
		...dealEventLogControllerGetDealEventsInfiniteOptions({
			headers: { 'deal-id': dealId },
			query: { limit: DEAL_EVENT_PAGE_SIZE, ...filters },
		}),
		initialPageParam: {},
		getNextPageParam: (lastPage) => lastPage.nextCursor,
		enabled: !!dealId,
	});

	const events = useMemo(
		() => query.data?.pages.flatMap((page) => page.events) ?? [],
		[query.data]
	);

	return { ...query, events };
};
